"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayerType = exports.RelayerTaskStatus = exports.ExecutorDataSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const primitives_1 = require("./primitives");
exports.ExecutorDataSchema = typebox_1.Type.Object({
    executorVersion: typebox_1.Type.String(),
    transferId: primitives_1.TBytes32,
    origin: typebox_1.Type.String(),
    encodedData: typebox_1.Type.String(),
    routerAddress: primitives_1.TAddress,
});
var RelayerTaskStatus;
(function (RelayerTaskStatus) {
    RelayerTaskStatus["CheckPending"] = "CheckPending";
    RelayerTaskStatus["ExecPending"] = "ExecPending";
    RelayerTaskStatus["ExecSuccess"] = "ExecSuccess";
    RelayerTaskStatus["ExecReverted"] = "ExecReverted";
    RelayerTaskStatus["WaitingForConfirmation"] = "WaitingForConfirmation";
    RelayerTaskStatus["Blacklisted"] = "Blacklisted";
    RelayerTaskStatus["Cancelled"] = "Cancelled";
    RelayerTaskStatus["NotFound"] = "NotFound";
})(RelayerTaskStatus = exports.RelayerTaskStatus || (exports.RelayerTaskStatus = {}));
var RelayerType;
(function (RelayerType) {
    RelayerType["Gelato"] = "Gelato";
    RelayerType["Connext"] = "Connext";
    RelayerType["Mock"] = "Mock";
})(RelayerType = exports.RelayerType || (exports.RelayerType = {}));
//# sourceMappingURL=relayer.js.map